import { css } from '@emotion/react';

import useTheme from '../../hooks/useTheme';

export default () => {
  const { breakpoints, colors, spacing, borderRadius } = useTheme();

  return {
    title: css`
      font-family: 'FS Dillon Bold' !important;
      display: inline-block;
      font-size: 24px;
      font-weight: 700;
      color: ${colors.navy};
      text-decoration: none;
      @media screen and (min-width: 1601px) {
        font-size: 2.221rem;
      }
      ${breakpoints.mm_xl_xxl} {
        font-size: 2.221rem;
      }
      ${breakpoints.mm_l_xl} {
        font-size: 2.221rem;
      }
      ${breakpoints.mm_m_l} {
        font-size: 1.62rem;
      }
      ${breakpoints.mm_s_m} {
        color: ${colors.navy};
        font-size: 1.62rem;
        line-height: 2.62rem;
        font-weight: 700;
      }
      ${breakpoints.mm_xs_s} {
        font-size: 1.62rem;
      }
      ${breakpoints.mm_xxs_xs} {
        font-size: 1.62rem;
      }
    `,
    textWrapper: css`
      color: ${colors.white};
      padding: 6rem ${spacing.s} 1.5rem 1.5rem;
      h3 {
        margin-bottom: 0.3rem;
        color ${colors.navy};
      }
      button {
        background-color: ${colors.red};
        color: ${colors.white};
        max-width: 11rem;
        margin-top: ${spacing.s};
      }
      
      ${breakpoints.l}{
        padding: ${spacing.s} ${spacing.s} 1.5rem ${spacing.xl};
      }
    `,
    nextfixturesWrapper: mbNext => css`
      margin-bottom: ${mbNext}px;
    `,
    lastresultsWrapper: mbLast => css`
      margin-bottom: ${mbLast}px;
    `,
    standingspositionssWrapper: mbPos => css`
      margin-bottom: ${mbPos}px;
      margin-top: -9px;
      padding: ${spacing.xs} 0;
    `,
    imgWrapper: css`
      position: relative;
      padding-top: ${spacing.s};
      // Enable imgWrapper once get actual image
      display: none;
    `,
    imgContent: css`
      background: url(/images/common/partner-promo-mobile.jpg) 0 0 no-repeat;
      border-radius: ${borderRadius.l};

      ${breakpoints.m} {
        background: url(/images/common/partner-promo-team.jpg) 0 0 no-repeat;
        min-height: 14.1875rem;
        background-size: contain;
        display: grid;
        align-content: end;
        width: 100%;
      }
    `,
    middle: css`
      display: grid;
      grid-gap: ${spacing.xl};
      @media screen and (min-width: 1601px) {
        margin-top: 2.5rem;
        margin-left: 2rem;
        margin-bottom: -2.5rem;
      }
      ${breakpoints.mm_xl_xxl} {
        margin-top: 32px;
      }
      ${breakpoints.mm_l_xl} {
        margin-top: 50px;
        margin-bottom: -35px;
        padding: 0 0 0 2rem;
      }
      ${breakpoints.mm_m_l} {
        margin-top: 45px;
        margin-bottom: -35px;
        padding: 0 0 0 2rem;
      }
      ${breakpoints.mm_s_m} {
        margin-top: 35px;
        margin-bottom: -35px;
        padding: 0 2rem 0;
      }
      ${breakpoints.mm_xs_s} {
        margin-top: 32px;
        margin-bottom: -35px;
        padding: 0 2rem 0;
      }
    `,
    clubDescriptionWrapper: css`
      p {
        font-size: ${spacing.s};
        padding-bottom: 1.5rem;
        line-height: 1.375rem;
        letter-spacing: 0.02em;
        color: ${colors.darkGrey};
      }
      a {
        display: inline-block;
        color: ${colors.darkGrey};
      }
    `,
  };
};
